import useGetMediaInStore from 'modules/store/services/hooks/useGetMediaInStore';
import MediaManagerGalleryMode from 'modules/media/screens/Dashboard/LibraryList/GalleryMode';
import MediaManagerListMode from 'modules/media/screens/Dashboard/LibraryList/ListMode';
import useViewMode from 'modules/media/services/hooks/useViewMode';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useGetMediaExploreInStore } from 'modules/store/services/hooks/useGetMediaExploreInStore';
import MediaManagerGridModeV2 from 'modules/media/screens/Dashboard/LibraryList/GridModeV2';
import { Col, Text } from 'basic-ui-lib';
import useGetAllFoldersInStore from 'modules/media/services/hooks/useGetAllFolderInStore';

const MediaTabs = () => {
  const { id } = useParams<{ id: string }>();
  const { mediaInStore: data, mutate } = useGetMediaInStore(id || '');
  const { mode: viewMode, setViewMode } = useViewMode();
  const [, mutateFolders] = useGetAllFoldersInStore(id || '', true);
  const { items, pathStack, openFolder, onBack, currentPath } =
    useGetMediaExploreInStore(data, mutate);

  return (
    <Container>
      <Col gap={0}>
        <Text title_h5 semibold left>
          Media
        </Text>
        <Text body_1 medium left color='neutral.text.3'>
          Manage media available for this store
        </Text>
      </Col>
      <MediaManagerGalleryMode
        viewMode={viewMode}
        onChangeViewMode={setViewMode}
        path={pathStack}
        onBack={onBack}
        currentPath={currentPath}
        onSuccess={mutate}
        onSuccessFolder={mutateFolders}
      />
      {viewMode === 'list' ? (
        <MediaManagerListMode
          items={items}
          onOpenFolder={openFolder}
          currentPath={currentPath}
          onSuccess={mutate}
        />
      ) : (
        <MediaManagerGridModeV2
          items={items}
          onOpenFolder={openFolder}
          currentPath={currentPath}
          onSuccess={mutate}
          storeId={id || ''}
        />
      )}
    </Container>
  );
};

export default MediaTabs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`;
